import React from 'react';
import { toast } from 'react-toastify';


import Alert from 'components/Alert';
import { agent } from 'helpers/agent';
import { API_MYEDUZZ } from 'settings';
import { Icon } from '@eduzz/ui-antd-theme';

const message = (notRecovering: number) => (
  <div>
    Chegou a hora de aproveitar essa super promoção! Mas para você não ter muito trabalho nós te ajudaremos...
    <br />
    <br />
    Detectamos que você tem <b>{notRecovering}</b> produtos ativos para venda e que a Recuperação de Vendas Perdidas
    ainda está desligada. Se deseja aproveitar essa promoção nós ligaremos agora a Recuperação de Vendas Perdidas nesses
    produtos para você, <b>durante esse período de Black Friday</b>!
    <br />
    <br />
    Vai aproveitar ou ficar de fora?
  </div>
);

export const openModalBF = async (notRecovering: number) => {
  const confirm = await Alert.confirm({
    message: message(notRecovering),
    title: (
      <>
        BLACK FRIDAY - Taxa da Recuperação de Vendas Perdidas de <s>20%</s> por 5%
      </>
    ),
    buttonOk: (
      <>
        LIGAR RVP AGORA <Icon.Heart fill='currentColor' className='ml-1 text-(--uizz-antd-color-error)'  />
      </>
    ),
    buttonOkDanger: false,
    buttonCancel: (
      <>
        VOU PERDER ESSA <Icon.Frown className='ml-1'  />
      </>
    ),
    confirmation: true
  });

  if (confirm) {
    const fetchData = async () => {
      try {
        await agent.post(`${API_MYEDUZZ}/products/recovery/activate`, {});

        const success = (
          <>
            Muito bom, foi ativado RVP em todos os seus {notRecovering} produtos com sucesso! Tenha uma ótima Black
            Friday <Icon.Heart fill='currentColor' className='ml-1 text-(--uizz-antd-color-error)'  />
          </>
        );

        toast.success(success);
      } catch (error) {
        toast.error(error.message);
      }
    };

    return fetchData();
  }
};
